import type { TFunction } from 'i18next';

const STATUS_MAP: Record<string, string> = {
  pending: 'orders.statuses.pending',
  processing: 'orders.statuses.processing',
  'on-hold': 'orders.statuses.on-hold',
  completed: 'orders.statuses.completed',
  cancelled: 'orders.statuses.cancelled',
  refunded: 'orders.statuses.refunded',
  failed: 'orders.statuses.failed',
};

function translateStatus(status: string, t: TFunction): string {
  const key = STATUS_MAP[status.toLowerCase()];
  return key ? t(key) : status;
}

export function translateLegacyNotification(
  title: string,
  body: string,
  t: TFunction,
): { title: string; body: string } {
  let translatedTitle = title;
  let translatedBody = body;

  // "New Order #123"
  const newOrderMatch = title.match(/^New Order #(\d+)$/);
  if (newOrderMatch) {
    translatedTitle = t('notifications.tpl.newOrderTitle', { number: newOrderMatch[1] });
  }

  // "Order #123 Updated"
  const updatedMatch = title.match(/^Order #(\d+) Updated$/);
  if (updatedMatch) {
    translatedTitle = t('notifications.tpl.statusChangedTitle', { number: updatedMatch[1] });
  }

  // "Status changed from X to Y"
  const statusMatch = body.match(/^Status changed from (\S+) to (\S+)$/);
  if (statusMatch) {
    translatedBody = t('notifications.tpl.statusChangedBody', {
      oldStatus: translateStatus(statusMatch[1]!, t),
      newStatus: translateStatus(statusMatch[2]!, t),
    });
  }

  // "Low Stock: ProductName"
  const lowStockMatch = title.match(/^Low Stock: (.+)$/);
  if (lowStockMatch) {
    translatedTitle = t('notifications.tpl.lowStockTitle', { product: lowStockMatch[1] });
  }

  return { title: translatedTitle, body: translatedBody };
}
